// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__5Njyf","cardsRow":"styles_cardsRow__0vOa8"};